
export class Constants {
  public static API_ENDPOINT = '/api';
  public static API_CMS_ENDPOINT = '/api/cms';
  // tslint:disable-next-line:max-line-length
  public static ICONFIGURATOR_REGEX = /https:\/\/b2b2.fastco.ca\/configurator2.html\?year=\d+&make=\d+&model=\d+&submodel=\d+&opt=.+&size=\d+&vehicle=\d+&cb=\w+&txtmake=\w+&txtmodel=.+&txtsubmodel=.+&wheel=\d+&diam=\d+\.\d+/;
  public static ICONFIGURATOR_PAGE = 'configurator2.html';
  public static ICONFIGURATOR_LOCATION = '/fastco/iconfigurator/';

	// djb:url parameters
	public static MAKE_ROUTE_PARAM = 'carmake';
	public static YEAR_ROUTE_PARAM = 'caryear';
	public static MODEL_ROUTE_PARAM = 'carmodel';
	public static SUBMODEL_ROUTE_PARAM = 'carsubmodel';
	public static OPTIONS_ROUTE_PARAM = 'caroptions';
	public static COUNTRY_ROUTE_PARAM = 'country';
	public static SEASON_ROUTE_PARAM = 'season';
	public static PRODUCT_ID_ROUTE_PARAM = 'productid';
	public static PRODUCT_ID_ROUTE_PARAM_REAR = 'productidrear';
	public static ACCESSORY_CATEGORY_ROUTE_PARAM = 'categoryId';
	public static FLOW_ROUTE_PARAM = 'flow';
	public static QUANTITY_ROUTE_PARAM = 'qty';
	public static REAR_QUANTITY_ROUTE_PARAM = 'rearqty';
	public static WHEEL_STAGGER_ROUTE_PARAM = 'wheelstagger';
	public static TIRE_STAGGER_ROUTE_PARAM = 'tirestagger';
	public static DEFAULT_STAGGER_ROUTE_PARAM = 'defaultstagger';
	public static PAGE_PARAM = 'page';
	public static PAGE_SIZE_PARAM = 'pageSize';
	public static ORDER_BY_PARAM = 'orderBy';
	public static STYLE_FINISH_ROUTE_PARAM = 'stylefinish';
	public static WHEEL_DIAMETER_ROUTE_PARAM = 'wheelDiameter';
	public static WHEEL_WIDTH_ROUTE_PARAM = 'wheelWidth';
	public static WHEEL_OPTIONS_ROUTE_PARAM = 'options';
	public static CONCEPT_VEHICLE_ROUTE_PARAM = 'concept';

  //AWM-CP
  public static DEFAULT_AGGRESIVE_ROUTE_PARAM = 'defaultaggressive';

  public static STUDDING_DESCRIPTION = 'FC.PackageBuilderSummaryDescription.Studding';
  public static MOUNTING_AND_BALANCING_DESCRIPTION = 'FC.PackageBuilderSummaryDescription.MountingAndBalancing';

	// Search wheels by specs
	public static DIAMETER_ROUTE_PARAM = 'diameter';
	public static PCD_ROUTE_PARAM = 'pcd';
	public static WIDTH_ROUTE_PARAM = 'width';
	public static MIN_OFFSET_ROUTE_PARAM = 'minoffset';
	public static MAX_OFFSET_ROUTE_PARAM = 'maxoffset';
	public static ARCHIVE_PARAM = 'archive';

  // Search tires by specs
  public static SECTION_WIDTH_ROUTE_PARAM = 'sectionwidth';
  public static ASPECT_RATIO_ROUTE_PARAM = 'aspectratio';
  public static RIM_DIAMETER_ROUTE_PARAM = 'rimdiameter';

  // Search by text
  public static SEARCH_TEXT_PARAM = 'searchtext';

  public static FLOW_ROUTE_VALUE_TIRE = 'TIRES';

	public static ORDERS_HISTORY_HREF = '/fastfinder/Orders/OpenOrders';
	public static QUOTES_HISTORY_HREF = '/fastfinder/Quotes/History';
	public static PACKAGEBUILDER_HOME = '/fastfinder/home';
	public static SHOPPING_CART_HREF = '/fastfinder/Checkout/Shopping-Cart-Summary';
	public static ERROR_500_HREF = '/CMSMessages/Error.aspx';
	public static ERROR_404_HREF = '/CMSMessages/PageNotFound.aspx';
	//djb: hack
	//public static LOGIN_HREF = '/login.aspx';
	//public static LOGIN_HREF = '/fastco-b2b/login.aspx';
	public static LOGIN_HREF = '/Fastco-Canada/Login';

	public static PRODUCT_TYPE_ANY = 'Any'; // search by text.
	public static PRODUCT_TYPE_WHEEL = 'Wheels';
	public static PRODUCT_TYPE_TIRE = 'Tires';
	public static PRODUCT_TYPE_LABOUR = 'Labours';
	public static PRODUCT_TYPE_HARDWARE = 'Hardwares';
	public static PRODUCT_TYPE_ACCESSORY = 'Accessory';
	public static PRODUCT_TYPE_KIT = 'Kit';
	public static PRODUCT_TYPE_OEM_KIT = 'OEMKit';
	public static PRODUCT_TYPE_PACKAGEKIT = 'PackageKits';

  public static LABOUR_TYPE_STUDDING = 'Studding';
  public static LABOUR_TYPE_MOUNTING_AND_BALANCING = 'Mounting And Balancing';

	public static PRODUCT_TYPE_WARNING_WHEEL = 'Wheel';
	public static PRODUCT_TYPE_WARNING_TIRE = 'Tire';
	public static PRODUCT_TYPE_WARNING_ACCESSORY = 'Accessory';

	public static SIZE_DETAIL_LABEL = 'FC.ProductDetail.Label.Size';
	public static WEIGHT_DETAIL_LABEL = 'FC.ProductDetail.Label.Weight';
	public static OFFSET_DETAIL_LABEL = 'FC.ProductDetail.Label.Offset';
	public static BACK_SPACING_LABEL = 'FC.ProductDetail.Label.Backspacing';
	public static STANCE_DETAIL_LABEL = 'FC.ProductDetail.Label.Stance';
	public static DESCRIPTION_DETAIL_LABEL = 'FC.ProductDetail.Label.Description';
	public static UTQG_DETAIL_LABEL = 'FC.ProductDetail.Label.UTQG';
	public static UTOG_DETAIL_LABEL = 'FC.ProductDetail.Label.UTOG';
	public static ODI_DETAIL_LABEL = 'FC.ProductDetail.Label.ODI';
	public static ODP_DETAIL_LABEL = 'FC.ProductDetail.Label.ODP';
	public static RUNFLAT_DETAIL_LABEL = 'FC.ProductDetail.Label.RunFlat';
	public static AGGRESSIVE_OD_DETAIL_LABEL = "FC.ProductDetail.Label.AggressiveOD";
	public static AGGRESSIVE_WIDTH_DETAIL_LABEL = "FC.ProductDetail.Label.AggressiveWidth";
	public static FLAG_ORANGE_DETAIL_LABEL = "FC.ProductDetail.Label.FlagOrange";
	public static FLAG_MISSING_HARDWARE_DETAIL_LABEL = "FC.ProductDetail.Label.FlagMissingHardware";
	public static CONCEPT_DETAIL_LABEL = "FC.ProductDetail.Label.Concept";
	public static CATEGORY_DETAIL_LABEL = "FC.ProductDetail.Label.Category";
	public static STEP_BORE_LABEL = 'FC.ProductDetail.Label.StepBore';
	public static HUBEXTENSION_LABEL = 'FC.ProductDetail.Label.HubExtension';

	public static DetailLabelArticulated = 'FC.ProductDetail.Label.Articulated';
	public static DetailLabelBore = 'FC.ProductDetail.Label.Bore';
	//public static DetailLabelDimension = 'FC.ProductDetail.Label.Dimension';
	public static DetailLabelFinish = 'FC.ProductDetail.Label.Finish';
	public static DetailLabelHex = 'FC.ProductDetail.Label.Hex';
	public static DetailLabelInnerDepth = 'FC.ProductDetail.Label.InnerNutsDepth';
	public static DetailLabelMHz = 'FC.ProductDetail.Label.MHz';
	public static DetailLabelOemBrand = 'FC.ProductDetail.Label.OEMBrand';
	public static DetailLabelOemTpmsPartNo = 'FC.ProductDetail.Label.OEMTPMSPartNo';
	public static DetailLabelSizeOverallLength = 'FC.ProductDetail.Label.SizeOverallLength';
	public static DetailLabelPCD = 'FC.ProductDetail.Label.PCD';
	public static DetailLabelQuality = 'FC.ProductDetail.Label.Quality';
	public static DetailLabelRelearnNo = 'FC.OEMData.GroupName.TPMSLoad.ItemName.RelearnNo';
	public static DetailLabelRunFlat = 'FC.ProductDetail.Label.RunFlat';
	public static DetailLabelSeat = 'FC.ProductDetail.Label.Seat';
	public static DetailLabelShank = 'FC.ProductDetail.Label.Shank';
	public static DetailLabelStyle = 'FC.ProductDetail.Label.Style';
	public static DetailLabelThickness = 'FC.ProductDetail.Label.Thickness';
	public static DetailLabelThread = 'FC.ProductDetail.Label.Thread';
	public static DetailLabelTorque = 'FC.ProductDetail.Label.Torque';
	public static OuterDiameter = 'FC.ProductDetail.Label.OuterDiameter';

  public static QUANTITY_LABEL = 'FC.Label.Quantity';
  public static FRONT_LABEL = 'FC.Stagger.Label.Front';
  public static REAR_LABEL = 'FC.Stagger.Label.Rear';
  public static FRONT_QUANTITY_LABEL = 'FC.Stagger.Label.Front.Quantity';
  public static REAR_QUANTITY_LABEL = 'FC.Stagger.Label.Rear.Quantity';

	//public static BRAND_B2B = 'b2b';
	public static BRAND_B2B = 'fastfinder';
	public static BRAND_REPLIKA = 'Replika';
	public static BRAND_FASTWHEELS = 'Fast Wheels';
	public static BRAND_FASTHD = 'Fast HD';
	public static BRAND_BRAELIN = 'Braelin';
	public static STAGGER_REGEXP = /^(.*)_(front|rear)$/i;
	public static STAGGER_WIDTH = 'W';
	public static STAGGER_OFFSET = 'O';
	public static UNSTAGGER = 'S';
	public static CUSTOMER_SIZE = 'CustomerSize';
	public static NA = 'N/A';


  public static ICONFIG_CAR_URL = '/fastco/assets/eye_black.png';
  public static ICONFIG_CAR_DISABLED_URL = '/fastco/assets/car_disabled.png';

  public static POSSIBLE_BRANDS = [
    Constants.BRAND_B2B,
    Constants.BRAND_REPLIKA,
    Constants.BRAND_FASTWHEELS,
    Constants.BRAND_FASTHD,
    Constants.BRAND_BRAELIN
  ];

  public static FIND_A_DEALER_LINK = '/Find-a-Dealer';
}

export enum HTTPStatusCode {
  NO_CONTENT = 204
}

export class PositionValues {
  public static BOTH = 'B';
  public static FRONT = 'F';
  public static REAR = 'R';
}

export class Positions {
  public static FRONT = 'front';
  public static REAR = 'rear';
}

export class SortDirections {
  public static ASC = 'Asc';
  public static DESC = 'Desc';
  public static NONE = '';
}

export enum AccessoryCategory {
	BilletWheelAdapters = 3,
	Bolts = 5,
	Box = 6,
	CapScrew = 8,
	CenterCaps = 9,
	DerbyCaps = 13,
	Emblem = 16,
	Foam = 18,
	HubCaps = 24,
	HubRings = 25,
	Inserts = 28,
	InsertScrew = 29,
	InstallationKit = 30,
	Label = 34,
	LockBolts = 37,
	LockKey = 38,
	LockNuts = 39,
	LockNutsET = 40,
	Nuts = 47,
	NutsET = 48,
	PackagedBolts = 49,
	PackagedNuts = 50,
	Promotional = 54,
	RackScrew = 55,
	Rivets = 57,
	SalesAids = 58,
	WheelSpacers = 59,
	SpecialValves = 60,
	Stud = 62,
	WheelStuds = 63,
	Tools = 66,
	TPMS = 68,
	TireValves = 71,
	ValveCap = 72,
	ValveCores = 73,
	Washers = 76,
	WheelWeights = 77,
	Keys = 90,
	OptionalValves = 91,
	Adapters = 92,
	// djb:note-used internally 
	Mounting = -1,
	Studding = -2
}


/* Should be a String Enum, but isn't supported in our project */
export class WheelFilterCategoryName {
  public static readonly SHOW = 'show';
  public static readonly STAGGER = 'wheelstagger';
}

export class TireFilterCategoryName {
  public static readonly SHOW = 'show';
  public static readonly STAGGER = 'tirestagger';
}



